import React from "react";
import { ClipboardCheckIcon, FlaskConicalIcon, MapIcon, ShieldPlusIcon, FolderOpenIcon, BoxIcon } from "lucide-react";
import { SectionCTA } from "./SectionCTA";
import { resources } from "../data/content";
const icons: Record<(typeof resources)[number]['key'], BoxIcon> = {
  checklists: ClipboardCheckIcon,
  worksheets: FlaskConicalIcon,
  maps: MapIcon,
  safety: ShieldPlusIcon,
  docs: FolderOpenIcon
};
export function Library() {
  return <section className="bg-white px-5 py-16 md:py-24" aria-labelledby="library-title" data-id="element-217" data-mp="2wchr6prrowh5">
      <div className="mx-auto max-w-4xl" data-id="element-218" data-mp="31a9jvm08kmme">
        <div className="text-center" data-id="element-219" data-mp="2nb0fdjle7gy9">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-brandDark" data-id="element-220" data-mp="2n9yu6manxe2t">Your Complete TRT Clinical Reference Library</p>
          <h2 id="library-title" className="mt-3 font-display text-3xl font-black leading-tight text-ink md:text-5xl" data-id="element-221" data-mp="2reoow7tl4mm5">
            More Than Six Documents: A Structured Collection of Practical Educational Tools
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-slate-600" data-id="element-222" data-mp="3lp18pz3ad4u8">
            Alongside the six volumes, you’ll receive supporting resources designed to help you organize information and review key considerations more efficiently.
          </p>
        </div>

        <ul className="mt-12 divide-y divide-slate-200 border-y border-slate-200" data-id="element-223" data-mp="3unedm04t9air">
          {resources.map(r => {
          const Icon = icons[r.key];
          return <li key={r.key} className="flex gap-4 py-6 md:gap-6" data-id="element-224" data-mp="8h80gf31g6ro">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-navy text-brand" data-id="element-225" data-mp="3jy2gb1l2ms8">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-226" data-mp="i7aqq7irz6mb" />
                </span>
                <div data-id="element-227" data-mp="d8zhnz0b1055">
                  <h3 className="font-display text-xl font-extrabold text-ink" data-id="element-228" data-mp="dakb1lavud1f">{r.title}</h3>
                  <p className="mt-1 leading-relaxed text-slate-600" data-id="element-229" data-mp="ra23cane08fj">{r.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl space-y-3 text-center text-lg leading-relaxed text-slate-600" data-id="element-230" data-mp="m831543dvhk6">
          <p data-id="element-231" data-mp="3l1083wqhmo27">Imagine having one organized reference collection to consult instead of rebuilding your research process every time you need to review a TRT-related question.</p>
          <p className="font-display text-2xl font-black text-ink" data-id="element-232" data-mp="3p0hd6p205j6u">That’s the purpose of TRT Blueprint.</p>
        </div>

        <SectionCTA label="Get the Six Volumes and All Five Bonuses" data-id="element-233" data-mp="2mzoa1usit1m" />
      </div>
    </section>;
}